import React from 'react';
import {ExpressCheckoutButtons} from '@wix/ecom-platform-express-checkout-buttons';
import {ProvidedGlobalProps, withGlobalProps} from '../../../providers/globalPropsProvider';
import {WidgetProps} from '@wix/cashier-express-checkout-widget/dist/src/types/WidgetProps';
import {PaymentAuthorizedArgs} from '@wix/cashier-express-checkout-widget/dist/src/types/ExternalContract';
import {
  ShippingContactRestricted,
  ShippingContactSelectedUpdate,
} from '@wix/cashier-express-checkout-widget/dist/src/types/Shipping';
import loadable from '@wix/yoshi-flow-editor/loadable';
import {withPropsChangeListeners, WithPropsChangeListenersProps} from '../../../providers/listenToPropsChanges';
import {OnPaymentAuthorizedResult} from '@wix/cashier-express-checkout-widget/src/types/ExternalContract';
import {ShippingMethod, ShippingMethodSelectedUpdate} from '@wix/cashier-express-checkout-widget/src/types/Shipping';

/* istanbul ignore next: code unreachable, should be removed when UseNewExpressCheckoutButtonsInProductPage FT is merged */
const CashierExpressCheckoutWidgetLazy = loadable<WidgetProps>(() =>
  import(
    /* webpackChunkName: "CashierExpressCheckoutWidget" */ '@wix/cashier-express-checkout-widget/dist/src/lazy'
  ).then((module) => module.CashierExpressCheckoutWidget)
);

class CashierExpressButtonComponent extends React.Component<ProvidedGlobalProps & WithPropsChangeListenersProps> {
  /* istanbul ignore next: code unreachable, should be removed when UseNewExpressCheckoutButtonsInProductPage FT is merged */
  public handleCashierPaymentSubmit = async (
    paymentInfo: PaymentAuthorizedArgs
  ): Promise<OnPaymentAuthorizedResult> => {
    if (paymentInfo.error) {
      return Promise.reject(paymentInfo.error);
    }

    this.props.globals.handleCashierPaymentSubmit(paymentInfo, this.props.globals.accessibilityEnabled);
    const submitPaymentResult = await this.props.waitForChange('handleCashierPaymentSubmitResult');

    return {
      result: submitPaymentResult.result,
    };
  };

  /* istanbul ignore next: code unreachable, should be removed when UseNewExpressCheckoutButtonsInProductPage FT is merged */
  public onPaymentMethodsAmountInit = (amount: number) => {
    this.props.globals.setDynamicPaymentsMethodsAmount(amount);
  };

  /* istanbul ignore next: code unreachable, should be removed when UseNewExpressCheckoutButtonsInProductPage FT is merged */
  private readonly onShippingMethodSelected = async (
    shippingMethod: ShippingMethod
  ): Promise<ShippingMethodSelectedUpdate> => {
    this.props.globals.cashierExpressWidgetOnShippingMethodSelected(shippingMethod);
    return this.props.waitForChange('cashierExpressWidgetOnShippingMethodSelectedResult');
  };

  /* istanbul ignore next: code unreachable, should be removed when UseNewExpressCheckoutButtonsInProductPage FT is merged */
  public handleExpressCashierShippingAddressChange = async (
    shippingAddress: ShippingContactRestricted
  ): Promise<ShippingContactSelectedUpdate> => {
    this.props.globals.fetchPaymentBreakdownForCashierAddress(shippingAddress);
    return this.props.waitForChange('fetchPaymentBreakdownForCashierAddressResult');
  };

  /* istanbul ignore next: code unreachable, should be removed when UseNewExpressCheckoutButtonsInProductPage FT is merged */
  public onClick = async () => {
    // todo(eran): results can't be tested with current cashier testKit because this callback doesn't actually opens cashier modal in tests
    this.props.globals.handleCashierOnClick();
    if (await this.props.waitForChange('handleCashierOnClickResult')) {
      return Promise.resolve({canceled: false});
    } else {
      return Promise.resolve({canceled: true});
    }
  };

  public render() {
    /* istanbul ignore next: code unreachable, should be removed when UseNewExpressCheckoutButtonsInProductPage FT is merged */
    const {meta, currency, locale, requestShipping, buttonStyle, domain, demoMode} =
      this.props.globals.cashierExpressCheckoutWidgetProps;
    /* istanbul ignore next: code unreachable, should be removed when UseNewExpressCheckoutButtonsInProductPage FT is merged */
    const {experiments, isAllowedToCheckout, dynamicPaymentMethodsTheme} = this.props.globals;
    /* istanbul ignore next: code unreachable, should be removed when UseNewExpressCheckoutButtonsInProductPage FT is merged */
    const {paymentAmount, paymentBreakdown, orderItems} = this.props.globals.cashierExpressPaymentBreakdown;

    /* istanbul ignore else: code unreachable, should be removed when UseNewExpressCheckoutButtonsInProductPage FT is merged */
    if (experiments.UseNewExpressCheckoutButtonsInProductPage) {
      return (
        <ExpressCheckoutButtons
          key={currency}
          layout="vertical"
          theme={dynamicPaymentMethodsTheme}
          buttonStyle={buttonStyle}
          isShippable={requestShipping}
          estimatedTotal={this.props.globals.cashierExpressEstimatedTotal}
          canStartPayment={isAllowedToCheckout}
        />
      );
    }

    /* istanbul ignore next: code unreachable, should be removed when UseNewExpressCheckoutButtonsInProductPage FT is merged */
    return (
      <CashierExpressCheckoutWidgetLazy
        key={currency}
        theme={dynamicPaymentMethodsTheme}
        buttonStyle={buttonStyle}
        currency={currency}
        locale={locale}
        domain={domain}
        meta={meta}
        onClick={this.onClick}
        onPaymentAuthorized={this.handleCashierPaymentSubmit}
        onShippingContactSelected={this.handleExpressCashierShippingAddressChange}
        onPaymentMethodsAmountInit={this.onPaymentMethodsAmountInit}
        onShippingMethodSelected={this.onShippingMethodSelected}
        orderItems={orderItems}
        paymentAmount={paymentAmount}
        paymentBreakdown={paymentBreakdown}
        paymentLabel="forApplePay"
        requestShipping={requestShipping}
        demoMode={demoMode}
      />
    );
  }
}

export const CashierExpressButton = withGlobalProps(withPropsChangeListeners(CashierExpressButtonComponent));
